import { useState, useEffect } from "react";
import styles from "./UserBookModal.module.css";
import { getMarketUserBook } from "../../apiServices/userBookService";
import UserBookLayout from "./UserBookLayout";
import { formatAmount } from "@/utils/constants";

export default function UserBookModal({ onClose, matchId, marketName, runners }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("ownerToken") || localStorage.getItem("staffToken") || localStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!token) {
          setError("Authentication token not found");
          setLoading(false);
          return;
        }

        // Determine API marketType from marketName
        let apiType = 'match_odds';
        const nameLower = (marketName || '').toLowerCase();

        if (nameLower.includes('bookmaker')) {
          apiType = 'bookmaker';
        } else if (nameLower.includes('fancy') || nameLower.includes('session')) {
          apiType = 'session'; // or fancy? usually session/fancy are mixed.
        } else if (nameLower.includes('match odds') || nameLower.includes('winner')) {
          apiType = 'match_odds';
        }

        const response = await getMarketUserBook(token, matchId, apiType);

        if (response.success) {
          setData(response.data || []);
        } else {
          setError(response.message || "Failed to fetch book");
        }
      } catch (err) {
        setError(err.message || "Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [matchId, marketName]);

  // Helper to format numbers — strips trailing zeros (456.00 → 456)
  const formatNumber = (num) => {
    if (num === undefined || num === null) return "0";
    return formatAmount(num);
  };

  const getNumberClass = (num) => {
    const val = Number(num);
    if (val > 0) return styles.positive;
    if (val < 0) return styles.negative;
    return styles.zero;
  };

  // Determine columns from data + props
  const columns = data.length > 0
    ? Array.from(new Set([...runners, ...data.flatMap(r => Object.keys(r.runners || {}))]))
    : runners;

  return (
    <UserBookLayout
      show={true}
      onHide={onClose}
      title="User Book"
      loading={loading}
    >
      {error && <div className={styles.error}>{error}</div>}

      <div className={styles.tableContainer}>
        <div className={styles.tableContent}>
          {/* Table Header */}
          <div className={styles.tableHeader}>
            <div className={styles.colUser}>User Name</div>
            {columns.map((runner, idx) => (
              <div key={idx} className={styles.colRunner}>{runner}</div>
            ))}
          </div>

          {/* User List */}
          <div className={styles.userList}>
            {loading ? <div className={styles.loading}>Loading...</div> : (
              data.length === 0 ? <div className={styles.loading}>No data found</div> :
                data.map((row) => (
                  <div key={row.userId} className={styles.userRow}>
                    <div className={styles.colUser}>{row.username}</div>
                    {columns.map((runner, idx) => {
                      const amount = row.runners[runner] || 0;
                      return (
                        <div key={idx} className={`${styles.colRunner} ${getNumberClass(amount)}`}>
                          {formatNumber(amount)}
                        </div>
                      );
                    })}
                  </div>
                ))
            )}
          </div>
        </div>
      </div>
    </UserBookLayout>
  );
}
